<template>
  <div
    class="column has-text-centered opportunity-item"
    :style="{ color: projectIsActive ? 'black' : '#d1d1d1' }"
  >
    <b-icon
      icon="lightbulb"
      :style="{ color: projectIsActive ? 'black' : '#d1d1d1' }"
    ></b-icon>
    <br />

    <span>Projeto</span>
  </div>
</template>

<script>
export default {
  props: ["projectIsActive"]
};
</script>

<style scoped>
div {
  font-size: 1rem;
}
</style>
